<template>
    <v-row class="my-3 mx-1">
        <v-col cols="8">
            <span style="font-weight: 500;font-size: 20px;">Biometrics</span> 
        </v-col>


        <v-col cols="3">
            <v-row  class="pa-3 calendar">

                <v-btn class="arrow mx-4" icon @click="prevDate">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <input type="date" v-model="selectedDate" />
                <!-- <span class="text-subtitle-1 font-weight-medium mx-5 mt-1">{{ formattedDate }}</span> -->

                <v-btn class="arrow mx-4" icon @click="nextDate">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                
            </v-row>
        </v-col>


        <v-col cols="1" class="upload">
            <v-progress-circular
            v-if="progress"
            color="primary"
            indeterminate
            >
            </v-progress-circular>

            <uploadFiles v-else
                @documentsData="documentsData($event)"
                type="bio"
                keyType="UP"
                :profile="true"
                :fileForUpload="fileForUpload"
                :inputType="InputType"
                />
        </v-col>
    </v-row>

    <v-table
        height="600px"
        fixed-header
        :style="{width:'100%',}"
    >
    <thead>
        <tr>
            <th class="text-left font-weight-bold table-header">
                Email
            </th>
            <th class="text-left font-weight-bold table-header">
                ProcessDate
            </th>
            <th class="text-left font-weight-bold table-header">
                StartDate
            </th>
            <th class="text-left font-weight-bold table-header">
                EndDate
            </th>
            <th class="text-left font-weight-bold table-header">
                Gross
            </th>
            <th class="text-left font-weight-bold table-header">
                Production
            </th>
            <th class="text-left font-weight-bold table-header">
                Break
            </th>
            <th class="text-left font-weight-bold table-header">
                Created
            </th>
            <!-- <th class="text-left font-weight-bold table-header">
                Modified
            </th> -->
        </tr>
    </thead>
    <tbody v-if="loading === true">
        <tr>
            <td colspan="10">
            <SkeletonForBiometric />
            </td>
        </tr>
    </tbody>

    <tbody v-else>
        <template v-if="biometrics.length > 0">
            <tr 
            v-for="(item,index) in biometrics"
            :key="index" :class="index % 2 === 0 ? 'even-row' : 'odd-row'"
            >
            <td>{{ item.email }}</td>
            <td :style="{color:color,fontWeight:font}">{{ item.process_date ? formatDate(item.process_date) : '' }}</td>
            <td :style="{color:color,fontWeight:font}">{{ item.start_date ? formatTime(item.start_date) : '' }}</td>
            <td :style="{color:color,fontWeight:font}">{{ item.end_date ? formatTime(item.end_date) : ''}}</td>
            <td>{{ item.gross_hours }}</td>
            <td>{{ item.total_production_hours }}</td>
            <td>{{ item.break_duration }}</td>
            <td :style="{color:color,fontWeight:font}">{{ item.created ? formatDateTime(item.created) : ''}}</td>
            <!-- <td :style="{color:color,fontWeight:font}">{{ item.modified ? formatDateTime(item.modified) : '' }}</td> -->
            </tr>
        </template>
        <tr v-else>
            <td colspan="10">
            <p class="no-data-container">Biometric data not available</p>
            </td>
        </tr>
    </tbody>
    </v-table>
    <v-snackbar v-model="showSnackbar" :timeout="3000" color="#fff">
      {{ snackbarText }}
    </v-snackbar>
</template>
<script>
    import BiometricService from '../../api/service/Biometrics/BiometricService'
    import dayjs from 'dayjs'
    import uploadFiles from "@/components/uploadFiles.vue";
    import SkeletonForBiometric from "../../modules/Biometrics/SkeletonForBiometric.vue";


    export default {
        components: {
            uploadFiles,
            SkeletonForBiometric,
        },
        data(){
            return {
                showSnackbar:false,
                snackbarText:'',
                loading: false,
                progress: false,
                color: 'orange',
                font : 'bold',
                selectedDate: '', 
                menu: false, 
                biometrics:[],
                attachmentId: [],
            }
        },

        mounted() {
            this.selectedDate = this.getTodayDate();
            this.getBiometricData();
        },


        watch: {
            selectedDate() {
                this.getBiometricData();
            }
        },

        computed: {
            formattedDate() {
            const [year, month, day] = this.selectedDate.split("-");
            return `${day}/${month}/${year}`; 
            },
        },

        methods: {
            async documentsData($event){
                this.progress = true;
                try {
                    console.log($event.url, "Uploading file");
                    
                    const response = await BiometricService.fileUpload({ path: $event.url });
                    if (response.length > 0) {
                        this.$store.dispatch("setSnackbar", { text: "File uploaded successfully" });
                    } else {
                    // this.snackbarText = 'Failed to upload file';
                    this.$store.dispatch("setSnackbar", {color:"error",text: "Failed to upload file" });
                    }
                } catch (error) {
                    console.error('Error uploading file:', error);
                    this.$store.dispatch("setSnackbar", {color:"error",text: "An error occurred while uploading the file" });
                    // this.snackbarText = 'An error occurred while uploading the file';
                } finally {
                    // this.showSnackbar = true;
                    this.progress = false;
                }
            },
            getTodayDate() {
                const today = new Date();
                const yyyy = today.getFullYear();
                const mm = String(today.getMonth() + 1).padStart(2, '0');
                const dd = String(today.getDate()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
            },

            async getBiometricData() {
                    this.loading = true;
                try {
                    const res = await BiometricService.getBiometricList({selectedDate : this.selectedDate});
                    console.log("Biometric data", res); 
                    this.biometrics = res?.length > 0 ? res : [];
                    this.loading = false;
                } catch (error) {
                    console.error("Failed to fetch biometric data:", error);
                    this.biometrics = [];
                }
            },


            async prevDate() {
                const date = new Date(this.selectedDate);
                date.setDate(date.getDate() - 1); 
                this.selectedDate = date.toISOString().split("T")[0];
            },

            async nextDate () {
                const date = new Date(this.selectedDate);
                date.setDate(date.getDate() + 1); 
                this.selectedDate = date.toISOString().split("T")[0];
            },

            formatTime(date) {
                return dayjs(date).format("HH:MM:ss");
            },

            formatDate(date) {
                return dayjs(date).format("DD/MM/YYYY");
            },

            formatDateTime(date){
                return dayjs(date).format("DD/MM/YYYY , HH:MM:ss");
            }
        },
}
</script>
<style scoped>
    .table-header {
        background-color: #1e6ca3 !important; 
        color: #fff; 
        font-weight: bold;
    }
    .arrow{
        color: #000;
        width: 0;
        height: 0;
        font-size: 18px;
    }
    .calendar{
        display: flex;
        justify-content: center;
    }
    .upload{
        text-align: center;
    }
    .even-row {
        background-color: #ffffff;
    }
    .odd-row {
        background-color: #eff5fc;
    }
    .no-data-container{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 500px;
        font-weight: 500;
    }
</style>
